var render = function render(){var _vm=this,_c=_vm._self._c;return _c('aside',{staticClass:"main_content",attrs:{"id":"main_content_div"}},[(_vm.$store.state.auth.me.roles.includes('client_sub') || _vm.$store.state.auth.me.roles.includes('client_sub'))?_c('section',{staticClass:"content"},[_c('div',{staticClass:"card test p-3"},[_vm._t("default")],2)]):_c('section',{staticClass:"content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }